import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type ISummaryPrimaryContentStyleClasses = 'ctaLink' | 'pricesContainer';

const summaryPrimaryContentStyles = makeStyles<ISpcTheme, ISummaryPrimaryContentStyleClasses>(
  theme => ({
    ctaLink: {
      paddingTop: theme.spacing(1.2),
      position: 'relative',
    },
    pricesContainer: {
      paddingTop: theme.spacing(1.2),
    },
  }),
  { name: 'Customise_SummaryPrimaryContent' },
);

export default summaryPrimaryContentStyles;
